var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxElipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47876 27.8808C4.48914 24.3598 0.966823 21.3449 4.21785 15.743C5.92754 12.797 10.7983 7.02275 15.3466 5.22985C19.0501 2.74656 22.5269 5.66577 24.6989 6.91335C29.2804 9.54478 26.3953 16.0941 23.1443 21.6959C19.8933 27.2978 13.0602 30.5122 8.47876 27.8808Z",
    fill: "#EF533F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0278 17.5441C11.8527 18.6382 13.6125 20.7719 14.0524 20.5531C14.6024 20.2795 17.627 15.9028 19.2768 14.8086",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxElipse);
export default __webpack_public_path__ + "static/media/checkbox-elipse.c6ac64e1fc2f11c0dd00cd1f1797a9eb.svg";
export { ForwardRef as ReactComponent };